/* @flow */
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import React from 'react';
import mountTymkPrompt from 'utils/mountTymkPrompt';

class PDFDownload extends React.Component {
  static propTypes = {
    type: React.PropTypes.oneOf(['link', 'button']).isRequired,
    group: React.PropTypes.object.isRequired,
    locale: React.PropTypes.string,
  };

  static defaultProps = {
    locale: 'en',
  };

  render() {
    const Component = this.props.type === 'link' ? Link : Button;

    return (
      <Component
        {...this.props}
        eventElementName="Pdf-download-link"
        eventProperties={{
          foreign_table: 'groups',
          foreign_id: this.props.group.id,
          locale: this.props.locale,
        }}
        href={this.props.group.getPdfUrl(this.props.locale)}
        target="_blank"
        onClick={() => {
          mountTymkPrompt(this, 'download_pdf');
        }}
      />
    );
  }
}

export default PDFDownload;



// WEBPACK FOOTER //
// ./src/components/PDFDownload.jsx